let mobileMenuLoaded = false

class MobileMenu extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (mobileMenuLoaded) return

    window.BAO.sectionRenderer
      .fetch(
        this.dataset.sectionId,
        `${window.Shopify.routes.root}?view=mobile-menu`,
      )
      .then((res) => {
        mobileMenuLoaded = true

        const newDOM = window.BAO.sectionRenderer.convertToDOM(
          res[this.dataset.sectionId],
        )
        const myself = newDOM.querySelector('mobile-menu')
        this.outerHTML = myself.outerHTML
      })
      .catch(() => {})
  }

  setupListeners () {
    super.setupListeners()

    if (!this.els.trigger?.exists) return

    this.handleDrawerChange = this.handleDrawerChange.bind(this)

    document.addEventListener('drawer-changed', this.handleDrawerChange)

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleBack = this.handleBack.bind(this)

    this.listeners.add(this, 'click', this.handleTrigger)
    this.listeners.add(this, 'click', this.handleBack)
  }

  handleTrigger (event) {
    const clickedTrigger = event.target.closest(this.els.trigger.selector)

    if (!clickedTrigger) return

    const matchedSubMenu = this.els.submenu.elements.find(
      (submenuEl) =>
        submenuEl.dataset.handle === clickedTrigger.dataset.handle &&
        submenuEl.dataset.level === clickedTrigger.dataset.level &&
        submenuEl.dataset.topNavHandle === clickedTrigger.dataset.topNavHandle,
    )

    if (!matchedSubMenu) return

    matchedSubMenu.classList.add('drw-Drawer-active')
    matchedSubMenu.showModal()
  }

  handleBack (event) {
    const backButtonEl = event.target.closest(this.els.back.selector)

    if (!backButtonEl) return

    const submenuEl = event.target.closest(this.els.submenu.selector)

    if (!submenuEl) return

    submenuEl.classList.remove('drw-Drawer-active')
    submenuEl.close()
  }

  handleDrawerChange () {
    this.els.submenu.elements.forEach((submenuEl) => {
      submenuEl.classList.remove('drw-Drawer-active')
      submenuEl.close()
    })
  }
}

if (!customElements.get('mobile-menu')) {
  customElements.define('mobile-menu', MobileMenu)
}
